import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import { Badge, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
export type FindingSeverity = 'critical' | 'high' | 'medium' | 'low';
export type EvidenceItem = {
  description: string;
  url?: string;
  url_label?: string;
};
export type Finding = {
  id: string;
  severity: FindingSeverity;
  title: string;
  description: string;
  evidence?: (string | EvidenceItem)[];
};
const normalizeEvidence = (ev: string | EvidenceItem): EvidenceItem => typeof ev === 'string' ? {
  description: ev
} : ev;
type FindingsCardProps = {
  title?: string;
  findings: Finding[];
  initialVisible?: number;
};
const SEVERITY_ORDER: Record<FindingSeverity, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3
};
type BadgeVariant = 'error' | 'warning' | 'neutral';
const SEVERITY_CONFIG: Record<FindingSeverity, {
  label: string;
  badgeVariant: BadgeVariant;
}> = {
  critical: {
    label: 'Critical',
    badgeVariant: 'error'
  },
  high: {
    label: 'High',
    badgeVariant: 'error'
  },
  medium: {
    label: 'Medium',
    badgeVariant: 'warning'
  },
  low: {
    label: 'Low',
    badgeVariant: 'neutral'
  }
};
const FindingsCard = t0 => {
  const $ = _c(18);
  const {
    title: t1,
    findings: t2,
    initialVisible: t3
  } = t0;
  const title = t1 === undefined ? "Key Findings" : t1;
  const findings = t2 === undefined ? [] : t2;
  const initialVisible = t3 === undefined ? 3 : t3;
  const [expanded, setExpanded] = useState(false);
  const sorted = [...findings].sort(_temp);
  const shown = expanded ? sorted : sorted.slice(0, initialVisible);
  const hidden = sorted.length - initialVisible;
  const t4 = "flex flex-col gap-3 w-full";
  let t5;
  if ($[0] !== title) {
    t5 = title && <span className="text-label-2 text-primary fp-text">{title}</span>;
    $[0] = title;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = "flex flex-col gap-3";
  const t7 = shown.map(_temp3);
  let t8;
  if ($[2] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[2] = t7;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== expanded || $[5] !== hidden || $[6] !== setExpanded) {
    t9 = !expanded && hidden > 0 && <div className="flex justify-center"><LinkButton iconComponent={IcoChevronDown16} iconPosition="left" onClick={() => setExpanded(true)}>{`${hidden} more finding${hidden !== 1 ? "s" : ""}`}</LinkButton></div>;
    $[4] = expanded;
    $[5] = hidden;
    $[6] = setExpanded;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== expanded || $[9] !== findings || $[10] !== initialVisible || $[11] !== setExpanded) {
    t10 = expanded && findings.length > initialVisible && <div className="flex justify-center"><LinkButton iconComponent={IcoChevronDown16} iconPosition="left" onClick={() => setExpanded(false)} className="[&_svg]:rotate-180">Show less</LinkButton></div>;
    $[8] = expanded;
    $[9] = findings;
    $[10] = initialVisible;
    $[11] = setExpanded;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t5 || $[15] !== t8 || $[16] !== t9) {
    t11 = <div className={t4}>{t5}{t8}{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export default FindingsCard;
function _temp(a, b) {
  return SEVERITY_ORDER[a.severity] - SEVERITY_ORDER[b.severity];
}
function _temp2(raw) {
  const ev = normalizeEvidence(raw);
  return <li key={ev.description} className="break-words text-caption-1 text-tertiary">{ev.description}{ev.url_label && (ev.url ? <>{" \u2014 "}<a href={ev.url} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-2">{ev.url_label}</a></> : <span>{` — ${ev.url_label}`}</span>)}</li>;
}
function _temp3(finding) {
  const cfg = SEVERITY_CONFIG[finding.severity];
  return <div key={finding.id} className="rounded-md border border-solid border-tertiary p-3 flex flex-col gap-3"><div className="flex items-start justify-between gap-3"><p className="min-w-0 break-words text-label-2 text-primary fp-text">{finding.title}</p><Badge className="flex-shrink-0" variant={cfg.badgeVariant}>{cfg.label}</Badge></div><p className="text-body-2 text-tertiary fp-text">{finding.description}</p>{finding.evidence && finding.evidence.length > 0 && <ul className="list-disc pl-6 marker:text-tertiary flex flex-col gap-1">{finding.evidence.map(_temp2)}</ul>}</div>;
}